import { useState } from "react";
import {
	Create,
	useCreate,
	useNotify,
	useRedirect,
	useRefresh,
	useTranslate,
} from "react-admin";
import { HandoutForm } from "./HandoutForm";

export const HandoutCreate = (props) => {
	const [isLoading, setIsLoading] = useState(false);
	const translate = useTranslate();
	const redirect = useRedirect();
	const refresh = useRefresh();
	const notify = useNotify();
	const [create] = useCreate("handouts");

	const onSuccess = () => {
		notify(translate("handouts.create.success"), "info");
		setIsLoading(false);
		redirect("/handouts");
		refresh();
	};

	const onFailure = (error) => {
		setIsLoading(false);
		notify(error.message, "warning");
	};

	const handleSave = (transformedData) => {
		setIsLoading(true);
		create(
			{ payload: { data: transformedData } },
			{
				onSuccess,
				onFailure,
			}
		);
	};

	return (
		<Create
			{...props}
			title={translate("handouts.create.title")}
		>
			<HandoutForm
				isEdit={false}
				onSave={handleSave}
				isLoading={isLoading}
			/>
		</Create>
	);
};